var app = angular.module("leonardo");

var PortfolioStates = function($stateProvider) {
  $stateProvider.state('portfolios', {
    url: '/portfolios',
    title: 'My Portfolios',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'portfolios.overview',
    ncyBreadcrumb: {
      label: 'My Portfolios'
    }
  });

  $stateProvider.state('portfolios.overview', {
    url: "/overview?fromOnboarding",
    title: 'My Portfolios',
    only_filter_account: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/portfolio/list.html',
        controller: 'PortfolioList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/portfolio-list.html',
        controller: 'PortfolioListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'PortfolioListFilters'
      }
    },
    ncyBreadcrumb: {
      skip: true
    }
  });

  $stateProvider.state('portfolios.groups', {
    url: "/groups",
    title: 'Property Groups',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/portfolio/groups.html',
        controller: 'GroupList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/property-groups-list.html',
        controller: 'PropertyGroupListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'PortfolioGroupListFilters'
      }
    },
    ncyBreadcrumb: {
      skip: true
    }
  });
};

app.config(['$stateProvider', PortfolioStates]);
